import Button from '@/src/common/components/marketing/buttons/Button'
import { ModalContent } from '@/src/modules/pg-plus/PGPlusStyledComponents'
import { BRAND_PG_PLUS } from '@/prisma/schemaConstants'
import { usePGPlusStepAndModalContext } from '@/src/common/contexts/PGPlusModalAndStepContext'
import { DISPATCH_HIDE_MODAL } from '@/src/common/reducers/constants'
import { useBrandSearchContext } from '@/src/modules/algolia/BrandSearchContext'
import { ModalButtonsWrapper } from '@/src/common/components/elements/Modals/StyledModalComponents'

interface ISelectBrandModal {
    changeBrand: Function
    isLoading: boolean
    isSuccess?: boolean
}

const SelectBrandModalContent = ({
    changeBrand,
    isLoading,
    isSuccess = false,
}: ISelectBrandModal) => {
    const { giftState, dispatch } = usePGPlusStepAndModalContext()
    const { brand: oldBrand } = giftState
    const { newBrandName } = useBrandSearchContext()
    const isBranded: boolean = Boolean(oldBrand && oldBrand !== BRAND_PG_PLUS)

    if (newBrandName && isBranded) {
        return (
            <ModalContent>
                <p className={'header'} data-testid={'modal-header'}>
                    Please confirm your gift brand change to{' '}
                    <span className={'gradient'}>{newBrandName}</span>
                </p>
                <p className={'body-text'} data-testid={'modal-text'}>
                    Once your request is submitted, you will not be able to use
                    your gift at {oldBrand}.
                </p>
                <ModalButtonsWrapper gap={'5px'} marginTop={'none'}>
                    <Button
                        label={'Confirm'}
                        type={'button'}
                        variant={'primary'}
                        width={'standard'}
                        showArrow={true}
                        textTransform={'uppercase'}
                        onClick={() => changeBrand()}
                        isLoading={isLoading || isSuccess}
                        disabled={isLoading || isSuccess}
                        data-testid={'confirm-button'}
                    />
                    <Button
                        label={'Go back'}
                        type={'button'}
                        variant={'primaryOutline'}
                        width={'standard'}
                        onClick={() => dispatch({ type: DISPATCH_HIDE_MODAL })}
                        disabled={isLoading || isSuccess}
                        showArrow={true}
                        textTransform={'uppercase'}
                        data-testid={'cancel-button'}
                    />
                </ModalButtonsWrapper>
            </ModalContent>
        )
    }

    if (newBrandName) {
        return (
            <ModalContent>
                <p className={'header'} data-testid={'modal-header'}>
                    Please confirm that you would like to use this gift at{' '}
                    <span className={'gradient'}>{newBrandName}</span>
                </p>
                <ModalButtonsWrapper gap={'5px'} marginTop={'none'}>
                    <Button
                        label={'Confirm'}
                        type={'button'}
                        variant={'primary'}
                        width={'standard'}
                        showArrow={true}
                        textTransform={'uppercase'}
                        onClick={() => changeBrand()}
                        isLoading={isLoading || isSuccess}
                        disabled={isLoading || isSuccess}
                        data-testid={'confirm-button'}
                    />
                    <Button
                        label={'Go back'}
                        type={'button'}
                        variant={'primaryOutline'}
                        width={'standard'}
                        onClick={() => dispatch({ type: DISPATCH_HIDE_MODAL })}
                        disabled={isLoading || isSuccess}
                        showArrow={true}
                        textTransform={'uppercase'}
                        data-testid={'cancel-button'}
                    />
                </ModalButtonsWrapper>
            </ModalContent>
        )
    }

    return (
        <ModalContent>
            <p className={'header'} data-testid={'modal-header'}>
                Please choose a brand
            </p>
            <p className={'body-text'} data-testid={'modal-text'}>
                In order to change the merchant on your gift, you must select a
                new brand merchant.
            </p>
            <ModalButtonsWrapper marginTop={'none'}>
                <Button
                    label={'Go back'}
                    type={'button'}
                    variant={'primaryOutline'}
                    width={'standard'}
                    onClick={() => dispatch({ type: DISPATCH_HIDE_MODAL })}
                    showArrow={true}
                    textTransform={'uppercase'}
                    data-testid={'cancel-button'}
                />
            </ModalButtonsWrapper>
        </ModalContent>
    )
}

export default SelectBrandModalContent
